// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accord-cadre section styles */
.accord-cadre-section,
.redressement-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
}

.accord-cadre-label-block,
.redressement-label-block {
  flex: 1 1;
}

.accord-cadre-label,
.redressement-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
  font-size: 1.1rem;
}

.accord-cadre-description,
.redressement-description {
  color: #4a5565;
  font-size: 0.98rem;
  margin-bottom: 16px;
}

.accord-cadre-switch-control,
.redressement-switch-control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* min-width: 80px; */
}

.accord-cadre-switch-control,
.redressement-switch-control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* min-width: 80px; */
}
.register-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f3f4f6;
}

.register-card {
  /* background-color: #fffdfc; */
  padding: 4rem;
  /* border-radius: 0.8rem; */
  /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); */
  width: 90%;
  max-width: 900px;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
}

.logo {
  width: 25rem;
  height: auto;
}

.register-card h1 {
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 500;
}

.register-card h2 {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #4a5565;
  font-weight: 400;
}

.register-container h3 {
  margin-bottom: 1.5rem;
}

.toggle-password-btn {
  position: absolute;
  right: 1.2rem;
  background: none;
  border: none;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-btn svg {
  width: 2rem;
  height: 2rem;
  color: #2c3948;
}

.toggle-password-btn:hover svg {
  color: #f97316;
}

.register-footer {
  margin-top: 2.4rem;
  text-align: center;
}

.login-link {
  font-size: 1.4rem;
  color: #2c3948;
}

.login-link a {
  color: #f97316;
  text-decoration: none;
  font-weight: 500;
}

.login-link a:hover {
  text-decoration: underline;
}

.form-group.si-acheteur {
  display: flex;
  align-items: center;
  gap: 2rem;
  font-weight: 700;
}

.si-acheteur .bouton-radio {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.si-acheteur .bouton-radio label {
  display: flex;
  align-items: center;
  margin: 0;
}

.si-acheteur label {
  margin: 0;
}

/* Style pour les sections prestataire/acheteur */
.prestataire-section,
.acheteur-form {
  margin-top: 20px;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Autocomplete styles */
.autocomplete-container {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  list-style-type: none;
  padding: 0;
  margin: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  max-height: 200px;
  overflow-y: auto;
}

.autocomplete-list li {
  padding: 10px;
  cursor: pointer;
}

.autocomplete-list li:hover {
  background-color: #f0f0f0;
}

.organisme-input {
  padding-right: 40px;
  width: 100%;
}

.icon-container {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  height: 100%;
}

/* Section nouvel organisme */
.nouveau-organisme-section {
  background-color: rgba(215, 217, 217, 0.2);
  padding: 15px;
  border-radius: 10px;
  margin: 15px 0;
  border: 1px solid #e9ecef;
}

.nouveau-organisme-section h3 {
  margin-bottom: 1.5rem;
}

/* Bouton "Voir les Conditions Générales" */
.cgv-view-button {
  background-color: #f97316;
  color: #fff;
  border: none;
  padding: 1rem;
  border-radius: 3rem;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;
  width: 48%;
}

.cgv-view-button:hover {
  background-color: #bf5d20;
}

.cgv-view-button:focus {
  outline: none;
}

/* Conteneur pour les boutons d'actions */
.form-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

/* Style pour le bouton de soumission */
.submit-button {
  width: 48% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 1rem !important;
}

.form-group.cgv-container {
  margin: 2.5rem 0;
  padding: 1.5rem;
  border-radius: 0.8rem;
  background-color: #f8f9fa;
  border: 1px solid #eaeaea;
}

.inscription-warning-box {
  border: 2px solid #dc2626;
  background-color: #fef2f2;
  color: #991b1b;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 1.3rem;
  line-height: 1.6;
}

.inscription-warning-box p {
  margin: 0;
}

.organisme-departement-info {
  font-size: 0.85rem;
  color: #6b7280;
  margin-top: -8px;
  margin-bottom: 12px;
}

.form-group.cgv-container .checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.form-group.cgv-container .checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  flex-shrink: 0;
}

/* Plusieurs cases dans la meme boite grise : espacer les labels empiles */
.form-group.cgv-container .checkbox-label + .checkbox-label {
  margin-top: 1.25rem;
}

/* Case avec texte long (delibration) : aligner la case en haut, pas au centre */
.form-group.cgv-container .checkbox-label.align-top {
  align-items: flex-start;
}

.form-actions-container button {
  width: 48%;
}

.form-actions button:disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

.cgv-accepted-message {
  color: #28a745;
  font-weight: 600;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid #28a745;
  border-radius: 5rem;
  background-color: rgba(40, 167, 69, 0.1);
  width: 100%;
}

.check-icon {
  font-size: 2rem;
}

.cgv-link-button {
  background: none;
  border: none;
  color: #f97316;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 1rem;
  font-weight: 500;
  padding: 0;
}

.cgv-error {
  color: #dc2626;
  margin-top: 1rem;
  font-size: 1.4rem;
  text-align: center;
  font-weight: 500;
}

.account-type-cards {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin: 5rem 0;
}

.account-type-card {
  flex: 1 1;
  padding: 2rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  text-align: center;
  cursor: pointer;
  transition:
    border-color 0.3s ease,
    box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: #fffdfc;
}

.account-type-card button,
.form-actions-container .cgv-view-button,
.form-actions-container .submit-button {
  border-radius: 1rem !important;
}

.account-type-card button {
  width: 100%;
}

.account-type-card h3 {
  margin: 0;
  font-size: 1.6rem;
  color: #0a0a0a;
}

.account-type-card p {
  font-size: 1.25rem;
  color: #4a5565;
  margin-bottom: 1rem;
}

.account-type-card .prestataire-icon {
  margin-bottom: 1.5rem;
}

.no-scale-button {
  transform: none !important;
}

/* Card de vérification SIRET */
.siret-verification-card {
  margin: 3rem 0;
  display: flex;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
}

.siret-card-content,
.prestataire-section,
.registration-success-card,
.acheteur-section {
  background-color: #fffdfc;
  padding: 3rem;
  border: 1px solid #e2e8f0;
  border-radius: 1.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.siret-card-content,
.registration-success-card {
  align-items: center;
  margin: 2rem auto 0;
}

.siret-card-content {
  max-width: 500px;
}

.registration-success-card {
  max-width: 450px;
}

.siret-icon {
  margin-bottom: 1rem;
}

.siret-card-content .form-group {
  width: 100%;
}

.siret-check-button,
.informations-entreprise-button,
.back-button.no-scale-button,
.profile-button.no-scale-button {
  border-radius: 1rem !important;
}

.back-button.no-scale-button:hover {
  color: #2c3948;
  border: 1px solid #e2e8f0 !important;
  background-color: #f3f4f6 !important;
}

.siret-card-content label {
  display: block;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  font-weight: 500;
  color: #2c3948;
}

.siret-card-content input {
  width: 100%;
  padding: 1.2rem;
  font-size: 1.6rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.8rem;
  transition: border-color 0.3s ease;
}

.siret-card-content input:focus {
  outline: none;
  border-color: #f97316;
}

.siret-card-content input.input-error {
  border-color: #dc2626;
}

.siret-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.siret-input-wrapper input {
  flex: 1 1;
}

.siret-insee-spinner {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-left: 10px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #f97316;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.siret-counter {
  margin-top: 1rem;
  font-size: 1.2rem;
  color: #4a5565;
  text-align: center;
}

.success-message {
  color: #16a34a;
  font-size: 1.4rem;
  font-weight: 500;
  margin-top: 0.5rem;
  display: block;
}

.siret-card-content button {
  width: 100%;
}

.siret-card-actions {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
}

.siret-card-actions .back-button,
.back-button.no-scale-button {
  background-color: #fff;
  border: 1px solid #e2e8f0;
  color: #4a5565;
  margin: 0;
  transform: none !important;
  border-radius: 1rem;
}

.siret-card-actions .back-button:hover {
  color: #2c3948;
  border: 1px solid #e2e8f0 !important;
  background-color: #f3f4f6 !important;
}

/* Styles pour la question sur le pays */
.pays-question-section,
.pays-selection-section,
.siret-input-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.pays-question-section label,
.pays-selection-section label {
  font-size: 1.4rem;
  font-weight: 500;
  color: #2c3948;
  text-align: center;
  margin-bottom: 1rem;
}

.pays-choice-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.pays-choice-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  padding: 2rem 2.5rem;
  background-color: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.3rem;
  color: #2c3948;
  min-width: 180px;
}

.pays-choice-btn:hover {
  border-color: #f97316;
  background-color: #fff8f3;
}

.pays-choice-btn:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(217, 112, 71, 0.2);
}

.pays-choice-btn .flag-emoji {
  font-size: 2.5rem;
}

/* Select pour le pays européen */
.pays-select {
  width: 100%;
  padding: 1.2rem;
  font-size: 1.4rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.8rem;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.pays-select:focus {
  outline: none;
  border-color: #f97316;
}

.pays-select option {
  padding: 0.8rem;
}

/* Info text sous le champ de saisie */
.siret-info-text {
  margin-top: 0.8rem;
  font-size: 1.1rem;
  color: #6b7280;
  text-align: center;
  font-style: italic;
}

.prestataire-form .form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
}

.form-row .form-group {
  flex: 1 1;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider (compact switch) */
.slider {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  background-color: #e2e8f0;
  border-radius: 24px;
  transition: background 0.3s;
  cursor: pointer;
  vertical-align: middle;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.input-disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  color: #888;
}

/* Responsive : passage en 1 colonne sur mobile */
@media (max-width: 600px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}

.form-header-container {
  display: flex;
  justify-items: start;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2.5rem;
}

.form-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.registration-success-card h3 {
  font-size: 2rem;
}

.registration-success-card p {
  font-size: 1.4rem;
  text-align: center;
  color: #973c00;
  padding: 2rem;
  border: #fee685 1px solid;
  border-radius: 0.8rem;
  background-color: #fffbeb;
}

.registration-success-card .profile-button {
  width: 100%;
  margin-top: 2rem;
}

/* Styles pour la sélection des départements */
.departements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fafafa;
}

.departement-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
  font-size: 0.9rem;
}

.departement-checkbox:hover {
  border-color: #d97947;
  background: #fff8f5;
}

.departement-checkbox.selected {
  border-color: #d97947;
  background: #fff3ed;
}

.departement-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #d97947;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
}

.departement-checkbox .dept-code {
  font-weight: 600;
  color: #d97947;
  min-width: 22px;
  flex-shrink: 0;
  text-align: right;
  line-height: 16px;
}

.departement-checkbox .dept-separator {
  color: #9ca3af;
  margin: 0 0.15rem;
  flex-shrink: 0;
  line-height: 16px;
}

.departement-checkbox .dept-nom {
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  text-align: left;
  line-height: 16px;
}

/* Header des départements avec bouton Tout sélectionner */
.departements-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.departements-header label {
  flex: 1 1;
}

.selected-count {
  margin-top: 0.75rem;
  padding: 0.5rem 1rem;
  background: #fff3ed;
  border-radius: 6px;
  color: #d97947;
  font-weight: 500;
  font-size: 0.9rem;
  text-align: center;
}

.label-hint {
  font-weight: 400;
  color: #6b7280;
  font-size: 0.85rem;
}

.loading-message {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
}

/* Responsive pour la grille des départements */
@media (max-width: 600px) {
  .departements-grid {
    grid-template-columns: 1fr;
    max-height: 250px;
  }
}

/* Styles pour les champs mot de passe */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  flex: 1 1;
  padding-right: 45px;
}

.password-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.password-toggle:hover {
  opacity: 1;
}

/* Validation du mot de passe */
.password-validation {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 8px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 0.85rem;
}

.validation-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.validation-item.valid {
  color: #16a34a;
}

.validation-item.invalid {
  color: #dc2626;
}

/* Indicateur de correspondance des mots de passe */
.password-match {
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
}

.password-match.match {
  background: #dcfce7;
  color: #166534;
}

.password-match.no-match {
  background: #fee2e2;
  color: #991b1b;
}

/* Erreur de formulaire en bas */
.form-error {
  margin: 1.5rem 0;
  padding: 1rem;
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #991b1b;
  font-size: 0.95rem;
  text-align: center;
}

/* Message info mot de passe */
.password-info {
  background: #fff4e6;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.password-info p {
  margin: 0;
  color: #ea580c;
  font-size: 0.95rem;
  text-align: center;
}

/* Bouton select all départements */
.departements-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

/* Multi-sélection lots techniques */
.selected-lots-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.selected-lot-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff4e6;
  border: 1px solid #fed7aa;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 0.9rem;
  color: #ea580c;
}

.remove-lot-btn {
  background: none;
  border: none;
  color: #ea580c;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.remove-lot-btn:hover {
  opacity: 1;
}

.lot-selector-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.lot-select {
  flex: 1 1;
}

.add-lot-btn {
  background: #d97947;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.add-lot-btn:hover:not(:disabled) {
  background: #c46a3d;
}

.add-lot-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}

/* Auto-complétion adresse prestataire */
.adresse-autocomplete-container {
  position: relative;
}

.adresse-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 250px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.adresse-suggestion-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f1f5f9;
}

.adresse-suggestion-item:last-child {
  border-bottom: none;
}

.adresse-suggestion-item:hover {
  background: #f8fafc;
}

.register-back-home-link {
  position: absolute;
  top: 1.75rem;
  left: 2rem;
  color: #6b7280;
  font-size: 1.2rem;
  text-decoration: none;
  transition: color 0.15s;
}

.register-back-home-link:hover {
  color: #f97316;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Register/Register.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,2BAA2B;EAC3B,mDAAmD;EACnD,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA,iDAAiD;AACjD;;EAEE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf;;wBAEsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;;;EAIE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,wCAAwC;AACxC;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Accord-cadre section styles */\n.accord-cadre-section,\n.redressement-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n  background: #fff;\n}\n\n.accord-cadre-label-block,\n.redressement-label-block {\n  flex: 1;\n}\n\n.accord-cadre-label,\n.redressement-label {\n  font-weight: 500;\n  margin-bottom: 8px;\n  display: block;\n  font-size: 1.1rem;\n}\n\n.accord-cadre-description,\n.redressement-description {\n  color: #4a5565;\n  font-size: 0.98rem;\n  margin-bottom: 16px;\n}\n\n.accord-cadre-switch-control,\n.redressement-switch-control {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* min-width: 80px; */\n}\n\n.accord-cadre-switch-control,\n.redressement-switch-control {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* min-width: 80px; */\n}\n.register-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f3f4f6;\n}\n\n.register-card {\n  /* background-color: #fffdfc; */\n  padding: 4rem;\n  /* border-radius: 0.8rem; */\n  /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); */\n  width: 90%;\n  max-width: 900px;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 3rem;\n}\n\n.logo {\n  width: 25rem;\n  height: auto;\n}\n\n.register-card h1 {\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.register-card h2 {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  color: #4a5565;\n  font-weight: 400;\n}\n\n.register-container h3 {\n  margin-bottom: 1.5rem;\n}\n\n.toggle-password-btn {\n  position: absolute;\n  right: 1.2rem;\n  background: none;\n  border: none;\n  padding: 0.6rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-password-btn svg {\n  width: 2rem;\n  height: 2rem;\n  color: #2c3948;\n}\n\n.toggle-password-btn:hover svg {\n  color: #f97316;\n}\n\n.register-footer {\n  margin-top: 2.4rem;\n  text-align: center;\n}\n\n.login-link {\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.login-link a {\n  color: #f97316;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.login-link a:hover {\n  text-decoration: underline;\n}\n\n.form-group.si-acheteur {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  font-weight: 700;\n}\n\n.si-acheteur .bouton-radio {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.si-acheteur .bouton-radio label {\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n\n.si-acheteur label {\n  margin: 0;\n}\n\n/* Style pour les sections prestataire/acheteur */\n.prestataire-section,\n.acheteur-form {\n  margin-top: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Autocomplete styles */\n.autocomplete-container {\n  position: relative;\n}\n\n.autocomplete-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 5px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.autocomplete-list li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.autocomplete-list li:hover {\n  background-color: #f0f0f0;\n}\n\n.organisme-input {\n  padding-right: 40px;\n  width: 100%;\n}\n\n.icon-container {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n/* Section nouvel organisme */\n.nouveau-organisme-section {\n  background-color: rgba(215, 217, 217, 0.2);\n  padding: 15px;\n  border-radius: 10px;\n  margin: 15px 0;\n  border: 1px solid #e9ecef;\n}\n\n.nouveau-organisme-section h3 {\n  margin-bottom: 1.5rem;\n}\n\n/* Bouton \"Voir les Conditions Générales\" */\n.cgv-view-button {\n  background-color: #f97316;\n  color: #fff;\n  border: none;\n  padding: 1rem;\n  border-radius: 3rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n  width: 48%;\n}\n\n.cgv-view-button:hover {\n  background-color: #bf5d20;\n}\n\n.cgv-view-button:focus {\n  outline: none;\n}\n\n/* Conteneur pour les boutons d'actions */\n.form-actions-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n/* Style pour le bouton de soumission */\n.submit-button {\n  width: 48% !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  padding: 1rem !important;\n}\n\n.form-group.cgv-container {\n  margin: 2.5rem 0;\n  padding: 1.5rem;\n  border-radius: 0.8rem;\n  background-color: #f8f9fa;\n  border: 1px solid #eaeaea;\n}\n\n.inscription-warning-box {\n  border: 2px solid #dc2626;\n  background-color: #fef2f2;\n  color: #991b1b;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  font-size: 1.3rem;\n  line-height: 1.6;\n}\n\n.inscription-warning-box p {\n  margin: 0;\n}\n\n.organisme-departement-info {\n  font-size: 0.85rem;\n  color: #6b7280;\n  margin-top: -8px;\n  margin-bottom: 12px;\n}\n\n.form-group.cgv-container .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.form-group.cgv-container .checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n/* Plusieurs cases dans la meme boite grise : espacer les labels empiles */\n.form-group.cgv-container .checkbox-label + .checkbox-label {\n  margin-top: 1.25rem;\n}\n\n/* Case avec texte long (delibration) : aligner la case en haut, pas au centre */\n.form-group.cgv-container .checkbox-label.align-top {\n  align-items: flex-start;\n}\n\n.form-actions-container button {\n  width: 48%;\n}\n\n.form-actions button:disabled {\n  background-color: #ccc !important;\n  color: #666 !important;\n  cursor: not-allowed;\n}\n\n.cgv-accepted-message {\n  color: #28a745;\n  font-weight: 600;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  border: 1px solid #28a745;\n  border-radius: 5rem;\n  background-color: rgba(40, 167, 69, 0.1);\n  width: 100%;\n}\n\n.check-icon {\n  font-size: 2rem;\n}\n\n.cgv-link-button {\n  background: none;\n  border: none;\n  color: #f97316;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 1rem;\n  font-weight: 500;\n  padding: 0;\n}\n\n.cgv-error {\n  color: #dc2626;\n  margin-top: 1rem;\n  font-size: 1.4rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.account-type-cards {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  margin: 5rem 0;\n}\n\n.account-type-card {\n  flex: 1;\n  padding: 2rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.8rem;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    border-color 0.3s ease,\n    box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  background-color: #fffdfc;\n}\n\n.account-type-card button,\n.form-actions-container .cgv-view-button,\n.form-actions-container .submit-button {\n  border-radius: 1rem !important;\n}\n\n.account-type-card button {\n  width: 100%;\n}\n\n.account-type-card h3 {\n  margin: 0;\n  font-size: 1.6rem;\n  color: #0a0a0a;\n}\n\n.account-type-card p {\n  font-size: 1.25rem;\n  color: #4a5565;\n  margin-bottom: 1rem;\n}\n\n.account-type-card .prestataire-icon {\n  margin-bottom: 1.5rem;\n}\n\n.no-scale-button {\n  transform: none !important;\n}\n\n/* Card de vérification SIRET */\n.siret-verification-card {\n  margin: 3rem 0;\n  display: flex;\n  justify-content: center;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.siret-card-content,\n.prestataire-section,\n.registration-success-card,\n.acheteur-section {\n  background-color: #fffdfc;\n  padding: 3rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 1.2rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.siret-card-content,\n.registration-success-card {\n  align-items: center;\n  margin: 2rem auto 0;\n}\n\n.siret-card-content {\n  max-width: 500px;\n}\n\n.registration-success-card {\n  max-width: 450px;\n}\n\n.siret-icon {\n  margin-bottom: 1rem;\n}\n\n.siret-card-content .form-group {\n  width: 100%;\n}\n\n.siret-check-button,\n.informations-entreprise-button,\n.back-button.no-scale-button,\n.profile-button.no-scale-button {\n  border-radius: 1rem !important;\n}\n\n.back-button.no-scale-button:hover {\n  color: #2c3948;\n  border: 1px solid #e2e8f0 !important;\n  background-color: #f3f4f6 !important;\n}\n\n.siret-card-content label {\n  display: block;\n  margin-bottom: 0.8rem;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #2c3948;\n}\n\n.siret-card-content input {\n  width: 100%;\n  padding: 1.2rem;\n  font-size: 1.6rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.8rem;\n  transition: border-color 0.3s ease;\n}\n\n.siret-card-content input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.siret-card-content input.input-error {\n  border-color: #dc2626;\n}\n\n.siret-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.siret-input-wrapper input {\n  flex: 1;\n}\n\n.siret-insee-spinner {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  margin-left: 10px;\n  border: 2px solid #e5e7eb;\n  border-top: 2px solid #f97316;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.siret-counter {\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  color: #4a5565;\n  text-align: center;\n}\n\n.success-message {\n  color: #16a34a;\n  font-size: 1.4rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.siret-card-content button {\n  width: 100%;\n}\n\n.siret-card-actions {\n  width: 100%;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.siret-card-actions .back-button,\n.back-button.no-scale-button {\n  background-color: #fff;\n  border: 1px solid #e2e8f0;\n  color: #4a5565;\n  margin: 0;\n  transform: none !important;\n  border-radius: 1rem;\n}\n\n.siret-card-actions .back-button:hover {\n  color: #2c3948;\n  border: 1px solid #e2e8f0 !important;\n  background-color: #f3f4f6 !important;\n}\n\n/* Styles pour la question sur le pays */\n.pays-question-section,\n.pays-selection-section,\n.siret-input-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.pays-question-section label,\n.pays-selection-section label {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #2c3948;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.pays-choice-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.pays-choice-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 2rem 2.5rem;\n  background-color: #fff;\n  border: 2px solid #e2e8f0;\n  border-radius: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.3rem;\n  color: #2c3948;\n  min-width: 180px;\n}\n\n.pays-choice-btn:hover {\n  border-color: #f97316;\n  background-color: #fff8f3;\n}\n\n.pays-choice-btn:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(217, 112, 71, 0.2);\n}\n\n.pays-choice-btn .flag-emoji {\n  font-size: 2.5rem;\n}\n\n/* Select pour le pays européen */\n.pays-select {\n  width: 100%;\n  padding: 1.2rem;\n  font-size: 1.4rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.8rem;\n  background-color: #fff;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n\n.pays-select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.pays-select option {\n  padding: 0.8rem;\n}\n\n/* Info text sous le champ de saisie */\n.siret-info-text {\n  margin-top: 0.8rem;\n  font-size: 1.1rem;\n  color: #6b7280;\n  text-align: center;\n  font-style: italic;\n}\n\n.prestataire-form .form-row {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 15px;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider (compact switch) */\n.slider {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n  background-color: #e2e8f0;\n  border-radius: 24px;\n  transition: background 0.3s;\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196f3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.input-disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  color: #888;\n}\n\n/* Responsive : passage en 1 colonne sur mobile */\n@media (max-width: 600px) {\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n\n.form-header-container {\n  display: flex;\n  justify-items: start;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 2.5rem;\n}\n\n.form-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.registration-success-card h3 {\n  font-size: 2rem;\n}\n\n.registration-success-card p {\n  font-size: 1.4rem;\n  text-align: center;\n  color: #973c00;\n  padding: 2rem;\n  border: #fee685 1px solid;\n  border-radius: 0.8rem;\n  background-color: #fffbeb;\n}\n\n.registration-success-card .profile-button {\n  width: 100%;\n  margin-top: 2rem;\n}\n\n/* Styles pour la sélection des départements */\n.departements-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.5rem;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 0.5rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.departement-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #fff;\n  font-size: 0.9rem;\n}\n\n.departement-checkbox:hover {\n  border-color: #d97947;\n  background: #fff8f5;\n}\n\n.departement-checkbox.selected {\n  border-color: #d97947;\n  background: #fff3ed;\n}\n\n.departement-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #d97947;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.departement-checkbox .dept-code {\n  font-weight: 600;\n  color: #d97947;\n  min-width: 22px;\n  flex-shrink: 0;\n  text-align: right;\n  line-height: 16px;\n}\n\n.departement-checkbox .dept-separator {\n  color: #9ca3af;\n  margin: 0 0.15rem;\n  flex-shrink: 0;\n  line-height: 16px;\n}\n\n.departement-checkbox .dept-nom {\n  color: #374151;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  text-align: left;\n  line-height: 16px;\n}\n\n/* Header des départements avec bouton Tout sélectionner */\n.departements-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.departements-header label {\n  flex: 1;\n}\n\n.selected-count {\n  margin-top: 0.75rem;\n  padding: 0.5rem 1rem;\n  background: #fff3ed;\n  border-radius: 6px;\n  color: #d97947;\n  font-weight: 500;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.label-hint {\n  font-weight: 400;\n  color: #6b7280;\n  font-size: 0.85rem;\n}\n\n.loading-message {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n}\n\n/* Responsive pour la grille des départements */\n@media (max-width: 600px) {\n  .departements-grid {\n    grid-template-columns: 1fr;\n    max-height: 250px;\n  }\n}\n\n/* Styles pour les champs mot de passe */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  flex: 1;\n  padding-right: 45px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.password-toggle:hover {\n  opacity: 1;\n}\n\n/* Validation du mot de passe */\n.password-validation {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-top: 8px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.validation-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.validation-item.valid {\n  color: #16a34a;\n}\n\n.validation-item.invalid {\n  color: #dc2626;\n}\n\n/* Indicateur de correspondance des mots de passe */\n.password-match {\n  margin-top: 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.password-match.match {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.password-match.no-match {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Erreur de formulaire en bas */\n.form-error {\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: #fee2e2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #991b1b;\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n/* Message info mot de passe */\n.password-info {\n  background: #fff4e6;\n  border: 1px solid #fed7aa;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.password-info p {\n  margin: 0;\n  color: #ea580c;\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n/* Bouton select all départements */\n.departements-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n/* Multi-sélection lots techniques */\n.selected-lots-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.selected-lot-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff4e6;\n  border: 1px solid #fed7aa;\n  border-radius: 20px;\n  padding: 6px 12px;\n  font-size: 0.9rem;\n  color: #ea580c;\n}\n\n.remove-lot-btn {\n  background: none;\n  border: none;\n  color: #ea580c;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.remove-lot-btn:hover {\n  opacity: 1;\n}\n\n.lot-selector-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.lot-select {\n  flex: 1;\n}\n\n.add-lot-btn {\n  background: #d97947;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.add-lot-btn:hover:not(:disabled) {\n  background: #c46a3d;\n}\n\n.add-lot-btn:disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n}\n\n/* Auto-complétion adresse prestataire */\n.adresse-autocomplete-container {\n  position: relative;\n}\n\n.adresse-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  max-height: 250px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.adresse-suggestion-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.adresse-suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.adresse-suggestion-item:hover {\n  background: #f8fafc;\n}\n\n.register-back-home-link {\n  position: absolute;\n  top: 1.75rem;\n  left: 2rem;\n  color: #6b7280;\n  font-size: 1.2rem;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.register-back-home-link:hover {\n  color: #f97316;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
